import(/* webpackMode: "eager" */ "/home/runner/work/apps/apps/packages/user-web-app/app/global-error.tsx");
